import { useEffect, useState } from "react";
import "./Adminconsole.css";
import "./adminCompact.css";
import Wingpage from "./Wing";
import Circlepage from "./Circle";
import Division from "./DivisionList";
import Subdivision from "./SubDivisionList";
import User from "./Latestuserlist";
import Area from "./Arealist";
import MasterTab from "./Master";
import { Dropdown, DropdownButton } from "react-bootstrap";
import {
  IoGridOutline,
  IoMapOutline,
  IoGitNetworkOutline,
  IoBusinessOutline,
  IoRadioButtonOnOutline,
  IoLayersOutline,
  IoPeopleOutline,
} from "react-icons/io5";
import { useSelector } from "react-redux";

function WorkDetails() {
  const [wingstatus, setWingstatus] = useState(false);
  const [circlest, setCirclest] = useState(false);
  const [divist, setDivist] = useState(false);
  const [subdivst, setSubdivst] = useState(false);
  const [master, setMaster] = useState(false);
  const [rolest, setRolest] = useState(false);
  const [userst, setUserst] = useState(false);
  const [areast, setAreast] = useState(false);

  const [selectedItem, setSelectedItem] = useState(
    sessionStorage.getItem("adminConsoleActiveTab") || "Master Tab",
  );

  const tabSetters = {
    "Master Tab": setMaster,
    Area: setAreast,
    "Area List": setAreast,
    "Sub-Division": setSubdivst,
    "Sub-Division List": setSubdivst,
    Division: setDivist,
    "Division List": setDivist,
    Circle: setCirclest,
    "Circle List": setCirclest,
    Wing: setWingstatus,
    User: setUserst,
    "User List": setUserst,
    "Role List": setRolest,
  };

  const userData = useSelector((state) => state.userDetails);

  // Keep the console exactly one viewport tall (under the sticky header) and
  // stop the window itself from scrolling; long content scrolls internally.
  useEffect(() => {
    const root = document.documentElement;
    const header = document.querySelector(".headersizediv");

    const applyOffset = () => {
      const height = header ? header.getBoundingClientRect().height : 0;
      root.style.setProperty(
        "--admin-header-offset",
        `${Math.round(height)}px`,
      );
    };

    root.classList.add("admin-console-open");
    applyOffset();

    const observer =
      typeof ResizeObserver !== "undefined" && header
        ? new ResizeObserver(applyOffset)
        : null;
    if (observer && header) observer.observe(header);

    window.addEventListener("resize", applyOffset);
    const timer = window.setTimeout(applyOffset, 250);

    return () => {
      root.classList.remove("admin-console-open");
      root.style.removeProperty("--admin-header-offset");
      if (observer) observer.disconnect();
      window.removeEventListener("resize", applyOffset);
      window.clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    const adminConsoleActiveTab = sessionStorage.getItem(
      "adminConsoleActiveTab",
    );

    if (adminConsoleActiveTab === "Master Tab") {
      setMaster(true);
    } else if (adminConsoleActiveTab === "Area" || adminConsoleActiveTab === "Area List") {
      setAreast(true);
    } else if (adminConsoleActiveTab === "Sub-Division" || adminConsoleActiveTab === "Sub-Division List") {
      setSubdivst(true);
    } else if (adminConsoleActiveTab === "Division" || adminConsoleActiveTab === "Division List") {
      setDivist(true);
    } else if (adminConsoleActiveTab === "Circle" || adminConsoleActiveTab === "Circle List") {
      setCirclest(true);
    } else if (adminConsoleActiveTab === "Wing") {
      setWingstatus(true);
    } else if (adminConsoleActiveTab === "User" || adminConsoleActiveTab === "User List") {
      setUserst(true);
    } else if (adminConsoleActiveTab === "Role List") {
      setRolest(true);
    }
  }, []);

  const resetAllTabs = () => {
    setWingstatus(false);
    setCirclest(false);
    setDivist(false);
    setSubdivst(false);
    setMaster(false);
    setRolest(false);
    setUserst(false);
    setAreast(false);
  };

  useEffect(() => {
    const storedTabName = sessionStorage.getItem("adminConsoleActiveTab");

    if (storedTabName && tabSetters[storedTabName]) {
      resetAllTabs();
      tabSetters[storedTabName](true);
      setSelectedItem(storedTabName);
    } else {
      resetAllTabs();
      setMaster(true);
      setSelectedItem("Master Tab");
    }
  }, []);

  useEffect(() => {
    let currentActiveTabName = "Master Tab";

    if (master) currentActiveTabName = "Master Tab";
    else if (areast) currentActiveTabName = "Area";
    else if (subdivst) currentActiveTabName = "Sub-Division";
    else if (divist) currentActiveTabName = "Division";
    else if (circlest) currentActiveTabName = "Circle";
    else if (wingstatus) currentActiveTabName = "Wing";
    else if (userst) currentActiveTabName = "User";
    else if (rolest) currentActiveTabName = "Role List";

    sessionStorage.setItem("adminConsoleActiveTab", currentActiveTabName);
    setSelectedItem(currentActiveTabName);
  }, [master, areast, subdivst, divist, circlest, wingstatus, userst, rolest]);

  const handleMaster = () => {
    resetAllTabs();
    setMaster(true);
  };
  const handleAreadiv = () => {
    resetAllTabs();
    setAreast(true);
  };
  const handleSubdiv = () => {
    resetAllTabs();
    setSubdivst(true);
  };
  const handleDiv = () => {
    resetAllTabs();
    setDivist(true);
  };
  const handleCircle = () => {
    resetAllTabs();
    setCirclest(true);
  };
  const handleWing = () => {
    resetAllTabs();
    setWingstatus(true);
  };
  const handleUser = () => {
    resetAllTabs();
    setUserst(true);
  };
  const handleRole = () => {
    resetAllTabs();
    setRolest(true);
  };

  useEffect(() => {
    const storedTabName = sessionStorage.getItem("adminConsoleActiveTab");

    if (storedTabName !== "User List") {
      sessionStorage.removeItem("usermodelstatus");
      sessionStorage.removeItem("userrole");
      sessionStorage.removeItem("userrolestatus");
      sessionStorage.removeItem("usercanshow");
      sessionStorage.removeItem("userformdata");
      sessionStorage.removeItem("userareaList");
      sessionStorage.removeItem("userwingListt");
      sessionStorage.removeItem("usercircleList");
      sessionStorage.removeItem("userdivList");
      sessionStorage.removeItem("usersubdivList");
      sessionStorage.removeItem("userwing");
      sessionStorage.removeItem("usercircle");
      sessionStorage.removeItem("userdivision");
      sessionStorage.removeItem("usersubdiv");
      sessionStorage.removeItem("userarea");
      sessionStorage.removeItem("userfieldValues");
      sessionStorage.removeItem("useraeOptions");
      sessionStorage.removeItem("useradeOptions");
      sessionStorage.removeItem("userdeOptions");
      sessionStorage.removeItem("userseOptions");
      sessionStorage.removeItem("userceOptions");
    }
  }, [userst]);

  useEffect(() => {
    const storedTabName = sessionStorage.getItem("adminConsoleActiveTab");

    if (storedTabName !== "Master Tab") {
      sessionStorage.removeItem("masterselectedWing");
      sessionStorage.removeItem("masterselectedCircle");
      sessionStorage.removeItem("masterselectedDivision");
      sessionStorage.removeItem("masterselectedsubDivision");
      sessionStorage.removeItem("masterselectedarea");
      sessionStorage.removeItem("masterselectedprojectnam");
    }
  }, [master]);

  const BASE_TABS = ["Master Tab", "Area", "Sub-Division"];
  const ADMIN_TABS = ["Division", "Circle", "Wing"];

  function getTabs(role) {
    const adminTabs = role === "DE" ? [] : ADMIN_TABS;
    return [...BASE_TABS, ...adminTabs, "User"];
  }

  const tabsm = getTabs(userData.role);

  const handleSelect = (item) => {
    setSelectedItem(item);
    if (item === "Master Tab") handleMaster();
    else if (item === "Area" || item === "Area List") handleAreadiv();
    else if (item === "Sub-Division" || item === "Sub-Division List") handleSubdiv();
    else if (item === "Division" || item === "Division List") handleDiv();
    else if (item === "Circle" || item === "Circle List") handleCircle();
    else if (item === "Wing") handleWing();
    else if (item === "User" || item === "User List") handleUser();
    else if (item === "Role List") handleRole();
  };

  const tabIcon = (Icon, isActive) => (
    <Icon size={20} color={isActive ? "#FFB700" : "white"} aria-hidden="true" />
  );

  return (
    <div className="rounded-0 admin-console">
      <div className="py-md-4 py-2 pb-0 px-0 admin-console-tabs">
        <div className="container-fluid w-100 px-0">
          <div className="d-lg-none d-flex justify-content-center admin-console-mobile-nav">
            <DropdownButton
              className="dropdown-toggle1 "
              id="dropdown-basic-button"
              title={selectedItem || "Master Tab"}
            >
              {tabsm.map((tabname, index) => (
                <Dropdown.Item
                  key={`${tabname}-${index}`}
                  onClick={() => handleSelect(tabname)}
                >
                  {tabname}
                </Dropdown.Item>
              ))}
            </DropdownButton>
          </div>

          <div
            className={`d-none d-lg-flex justify-content-center mx-auto p-0 rounded adminpage admin-console-desktop-nav ${userData.role === "DE" ? "adminpagede" : ""}`}
          >
            <div className="text-center">
              <button
                onClick={handleMaster}
                onKeyDown={(e) => e.key === "Enter" && handleMaster()}
                className="clickable-element btn p-0"
                type="button"
              >
                <div className={`${master ? "tabMenuc" : ""}`}>
                  {tabIcon(IoGridOutline, master)}
                </div>
                <span
                  className={`fsi-12 text-nowrap ${master ? "color-master" : "color-default"}`}
                >
                  Master Tab
                </span>
              </button>
            </div>

            <div className="ml-5 text-center">
              <button
                onClick={handleAreadiv}
                onKeyDown={(e) => e.key === "Enter" && handleAreadiv()}
                className="clickable-element btn p-0"
                type="button"
                tabIndex={0}
              >
                <div className={`${areast ? "tabMenu0" : ""}`}>
                  {tabIcon(IoMapOutline, areast)}
                </div>
                <span
                  className={`fsi-12 text-nowrap ${areast ? "color-master" : "color-default"}`}
                >
                  Area
                </span>
              </button>
            </div>

            <div className="ml-5 text-center">
              <button
                onClick={handleSubdiv}
                onKeyDown={(e) => e.key === "Enter" && handleSubdiv()}
                className="clickable-element btn p-0"
                type="button"
                tabIndex={0}
              >
                <div className={`${subdivst ? "tabMenu1c" : ""}`}>
                  {tabIcon(IoGitNetworkOutline, subdivst)}
                </div>
                <span
                  className={`fsi-12 text-nowrap ${subdivst ? "color-master" : "color-default"}`}
                >
                  Sub-Division
                </span>
              </button>
            </div>

            {userData.role !== "DE" && (
              <div className="ml-5 text-center">
                <button
                  onClick={handleDiv}
                  onKeyDown={(e) => e.key === "Enter" && handleDiv()}
                  className="clickable-element btn p-0"
                  type="button"
                  tabIndex={0}
                >
                  <div className={`${divist ? "tabMenu2c" : ""}`}>
                    {tabIcon(IoBusinessOutline, divist)}
                  </div>
                  <span
                    className={`fsi-12 text-nowrap ${divist ? "color-master" : "color-default"}`}
                  >
                    Division
                  </span>
                </button>
              </div>
            )}

            {userData.role !== "DE" && (
              <div className="ml-5 text-center">
                <button
                  onClick={handleCircle}
                  onKeyDown={(e) => e.key === "Enter" && handleCircle()}
                  className="clickable-element btn p-0"
                  type="button"
                >
                  <div className={`${circlest ? "tabMenu3c" : ""}`}>
                    {tabIcon(IoRadioButtonOnOutline, circlest)}
                  </div>
                  <span
                    className={`fsi-12 text-nowrap ${circlest ? "color-master" : "color-default"}`}
                  >
                    Circle
                  </span>
                </button>
              </div>
            )}

            {userData.role !== "DE" && (
              <div className="ml-5 text-center ">
                <button
                  onClick={handleWing}
                  onKeyDown={(e) => e.key === "Enter" && handleWing()}
                  className="clickable-element btn p-0"
                  type="button"
                >
                  <div
                    className={`${wingstatus ? "tabMenu4c" : ""}`}
                  >
                    {tabIcon(IoLayersOutline, wingstatus)}
                  </div>
                  <span
                    className={`fsi-12 text-nowrap ${wingstatus ? "color-master" : "color-default"}`}
                  >
                    Wing
                  </span>
                </button>
              </div>
            )}

            <div className="ml-5 text-center">
              <button
                onClick={handleUser}
                onKeyDown={(e) => e.key === "Enter" && handleUser()}
                className="clickable-element btn p-0"
                type="button"
              >
                <div className={`${userst ? "tabMenu5" : ""}`}>
                  {tabIcon(IoPeopleOutline, userst)}
                </div>
                <span
                  className={`fsi-12 text-nowrap ${userst ? "color-master" : "color-default"}`}
                >
                  User
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="admin-console-content">
        {master && <MasterTab />}
        {areast && <Area />}
        {subdivst && <Subdivision />}
        {divist && <Division />}
        {circlest && <Circlepage />}
        {wingstatus && <Wingpage />}
        {userst && <User />}
      </div>
    </div>
  );
}

export default WorkDetails;
